import { gql } from '@apollo/client';

export const NUMBER_OF_ORDERS = gql`
  query getNumberOfOrders($customerAccessToken: String!) {
    customerAccessToken @client @export(as: "customerAccessToken")
    customer(customerAccessToken: $customerAccessToken) {
      id
      numberOfOrders
    }
  }
`;
export default {};
